import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function fetchOperators(user) {
  const url = `${NEW_BASE_URL}/v1/busDetail/alloperatorsForCity`;
  // let url = `${BASE_URL}`;
  const cityIds = [];
  if (user && user.cityIds && user.cityIds.length) {
    user.cityIds.forEach((id) => cityIds.push(id.toString()));
  }

  const agencyIds = [];
  if (user && user.agencyIds && user.agencyIds.length) {
    user.agencyIds.forEach((id) => agencyIds.push(id.toString()));
  }

  // TODO remove comments after testing

  // return reconServiceAPI(url, {
  //   id: "alloperatorsForCity",
  //   paramValue: {
  //     query: {
  //       id: "alloperatorsForCity",
  //       addOnFilter: { cityIdArr: cityIds }
  //     },
  //     model: "BusDayWise"
  //   }
  // });
  return newReconServiceAPI(url, {
    addOnFilter: { cityIdArr: cityIds, agencyIdArr: agencyIds },
  });
}
